import { render, staticRenderFns } from "./ProductActionForceMassDeleteDialog.vue?vue&type=template&id=b39008a6&"
import script from "./ProductActionForceMassDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductActionForceMassDeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports